/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFileZipAlt = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M4 2h10.414L20 7.586V22H4zm2 2v16h12V9h-1v1h-2V9h-2V4zm9 1.414V7h1.586z" />
        <path d="M15 11h-2v-1h2zm0 1v-1h2v1zm0 1h-2v-1h2zm0 1h2v-1h-2zm0 1v-1h-2v5h4v-4zm-1 3v-1h2v1z" />
      </g>
    </g>
  </Icon>
);
export { SvgFileZipAlt as FileZipAlt };
